"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildNavLinks = exports.buildLegal = exports.getAbsoluteUrl = exports.check_cta_url = exports.getConfig = exports.getBaseUrl = exports.images = exports.navConfig = exports.footerConfig = exports.gdprConfig = undefined;

var _gdpr = require("./configurations/gdpr.json");

var _gdpr2 = _interopRequireDefault(_gdpr);

var _nav = require("./configurations/nav.json");

var _nav2 = _interopRequireDefault(_nav);

var _footer = require("./configurations/footer.json");

var _footer2 = _interopRequireDefault(_footer);

var _utils = require("./utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.gdprConfig = _gdpr2.default;
exports.footerConfig = _footer2.default;
exports.navConfig = _nav2.default;
exports.images = _utils.images;
exports.getBaseUrl = _utils.getBaseUrl;
exports.getConfig = _utils.getConfig;
exports.check_cta_url = _utils.check_cta_url;
exports.getAbsoluteUrl = _utils.getAbsoluteUrl;
exports.buildLegal = _utils.buildLegal;
exports.buildNavLinks = _utils.buildNavLinks;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-config/dist/index.js
// module id = 96
// module chunks = 168707334958949